import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Truck, ShieldCheck, ArrowsClockwise } from "@phosphor-icons/react";
import { scrollToSection } from "@/lib/scroll";

const AyudaSection = ({ id, icon: Icon, title, children }) => (
  <section id={id} data-testid={`ayuda-${id}`} className="bg-white border border-black/10 rounded-2xl p-7 lg:p-10 scroll-mt-28">
    <h2 className="font-display text-2xl sm:text-3xl uppercase font-semibold text-[#111418] mb-4 flex items-center gap-3">
      <Icon size={26} weight="fill" className="text-[#FF5508] shrink-0" /> {title}
    </h2>
    <div className="text-black/65 text-sm leading-relaxed flex flex-col gap-3 max-w-3xl">{children}</div>
  </section>
);

export const Ayuda = () => {
  useEffect(() => {
    document.title = "Ayuda - Ruta 360";
    const hash = window.location.hash;
    if (hash.length > 1) scrollToSection(hash.slice(1));
  }, []);

  return (
    <div data-testid="ayuda-page" className="bg-white min-h-screen">
      <Header />
      <main className="pt-[100px]">
        <div className="max-w-4xl mx-auto px-6 py-12 lg:py-16 flex flex-col gap-6">
          <div>
            <p className="text-xs font-semibold text-[#FF5508] uppercase tracking-widest mb-2">Ayuda</p>
            <h1 className="font-display text-4xl sm:text-5xl uppercase font-semibold tracking-tight text-[#111418]">
              Compra con confianza
            </h1>
          </div>

          <AyudaSection id="envios" icon={Truck} title="Envíos">
            <p>Envío a todo México: $99. Gratis en compras desde $1,399 MXN.</p>
            <p>Veracruz y estados vecinos: 1 a 3 días · Resto de México: 3 días · Ejidos y zonas de difícil acceso: 3 a 7 días.</p>
            <p>Cuando tu pedido salga, te mandamos tu número de guía por WhatsApp o correo y puedes seguirlo en <Link to="/rastreo" className="text-[#FF5508]">Rastrear mi pedido</Link>.</p>
          </AyudaSection>

          <AyudaSection id="garantia" icon={ShieldCheck} title="Garantía">
            <p>Todos nuestros productos tienen 1 año de garantía contra defectos de fabricación.</p>
            <p>Si tu producto llega con algún defecto, escríbenos por WhatsApp con tu número de pedido y una foto, y lo resolvemos contigo: reparación, reemplazo o reembolso según el caso.</p>
          </AyudaSection>

          <AyudaSection id="cambios" icon={ArrowsClockwise} title="Cambios y devoluciones">
            <p>Tienes 7 días naturales desde que recibes tu pedido para pedir un cambio.</p>
            <p>El producto debe estar sin usar, con sus etiquetas y empaque original. Los detalles completos están en <Link to="/devoluciones" className="text-[#FF5508]">Cambios y devoluciones</Link>.</p>
          </AyudaSection>
        </div>
      </main>
      <Footer />
    </div>
  );
};
